/**
 *
 * 数据统计
 * https://www.showdoc.com.cn/1969596173167084/8935814173312460
 *
 */

import { commonPromise } from '../index.js'

// 跨域代理前缀
// const API_PROXY_PREFIX = '/api'
const API_PROXY_PREFIX = ''
const BASE_URL = API_PROXY_PREFIX
// const BASE_URL = process.env.VUE_APP_API_BASE_URL

const shortMessageApi = {
  dictionariesOld123: (params) => commonPromise({ params, url: `${BASE_URL}/sys/v1/common/win/type`, method: 'get' }), // 字典查询 old
  statistics: (data) => commonPromise({ data, url: `${BASE_URL}/report/home/sales/data/statistics`, method: 'post' }), // 首页销售数据统计
}

export default shortMessageApi
